import React, { useState } from 'react'

let Tooltip = ({
  children,
  title,
  wrap = false,
  align = 'left',
  topOffset = 0,
  width,
  style,
}) => {
  let [showAt, setShowAt] = useState(false)

  return (
    <div
      style={{ position: 'relative', ...style }}
      onMouseOver={e => setShowAt(e.target.clientTop + 30)}
      onMouseOut={() => setShowAt(null)}
    >
      {children}
      {showAt && title && (
        <div
          className={`text-white bg-dark rounded p-1 small ${
            wrap ? '' : 'text-nowrap'
          }`}
          style={{
            width,
            position: 'absolute',
            zIndex: 999, // dropdown z-index is 1000, so put it behind that
            top: `${showAt + topOffset}px`,
            right: align === 'right' ? '0px' : undefined,
            // top: 0
          }}
        >
          {title}
        </div>
      )}
    </div>
  )
}

export default Tooltip
